import React from "react";
import { Box } from "@mui/material";
import "./index.css";
import accTransform from "../../../utils/accTransform";
import CurrencyFormater from "../../../utils/CurrencyFormater";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { bankLogoMapper } from "../../../services/bankLogoMapper";
import logo from "../../../assets/TransactionDashboardIcons/InstantPay card icon.png";

const InstantPayTxnStatusCard = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const services = useSelector((state) => state.refreshToken.services);

  return (
    <>
      <Box className="flex w-5/6 h-full flex-col bg-white rounded-4xl items-center justify-between">
        <Box className="w-full flex flex-col gap-2 3xl:gap-4 6xl:gap-6">
          <div className="flex flex-col gap-6 p-4 mt-4 pb-4">
            <div className="text-3xl 4xl:text-4xl font-semibold text-[#27B882] w-full">
              ₹ {CurrencyFormater(props.amount)}
            </div>
            <div className="flex gap-4 w-full justify-center items-center">
              <div className="px-4 py-1 bg-white rounded-xl">
                <img
                  className="w-8 xl:w-10 3xl:w-12 5xl:w-14"
                  alt="logo"
                  src={logo}
                />
              </div>
              <div className="text-black text-2xl 4xl:text-3xl capitalize truncate ...">
                InstantPay Refill
              </div>
            </div>
          </div>
          <Box className="dashedLine"></Box>
          {props.txn_id.length == 1 ? (
            <Box className="detailsTextCreateVendor w-full">
              <div
                className="text-lg 3xl:text-xl 5xl:text-2xl 6xl:text-3xl
                antialiased truncate ..."
              >
                {accTransform(props.account)}
              </div>
              <div className="flex flex-row justify-between">
                <div className="flex flex-col">
                  <div
                    className="text-lg 3xl:text-xl 5xl:text-2xl 6xl:text-3xl
                    antialiased truncate ..."
                  >
                    {props.bank_acc_no}
                  </div>
                  <div className="text-gray-500 text-xs 3xl:text-sm 5xl:text-base 6xl:text-xl antialiased">
                    Payment method
                  </div>
                </div>
                <div className="flex flex-row justify-center w-2/6">
                  <img
                    className="w-[80%] self-center"
                    src={require("../../../assets/Banks/" +
                      bankLogoMapper(props?.bank_name) +
                      ".png")}
                    alt=""
                  />
                </div>
              </div>
            </Box>
          ) : (
            <div className="text-3xl 4xl:text-4xl font-semibold text-black w-full">
              {props.txn_id.length} transactions
            </div>
          )}
        </Box>
        <Box className="w-full  cursor-pointer h-[30%] xl:h-[25%] text-white rounded-4xl bg-[#7fb085] flex justify-evenly items-center gap-4">
          {props.txn_id.length == 1 && (
            <>
              <Link
                to={`/instantPay/txn/${props.txn_id}`}
                onClick={() => {
                  if (location.pathname === `/instantPay/txn/${props.txn_id}`) {
                    navigate(0);
                  }
                }}
                className="flex flex-col w-2/6 gap-4 items-center justify-center"
              >
                <Box className="w-3/6 flex justify-center">
                  <img
                    width={"70%"}
                    src={require("../../../assets/CreateTransactionIcons/View details.png")}
                    alt=""
                    srcSet=""
                  />
                </Box>
                <p>
                  Views transaction <br /> details
                </p>
              </Link>
              <div className="h-4/5 w-0.5 bg-white"></div>
            </>
          )}
          <Box
            className="flex flex-col w-2/6 gap-4 items-center justify-center"
            onClick={() => navigate("/instantpay_refill")}
          >
            <Box className="w-3/6 flex justify-center">
              <img
                width={"70%"}
                src={require("../../../assets/CreateTransactionIcons/Dashboard.png")}
                alt=""
                srcSet=""
              />
            </Box>
            <p>
              Go to <br /> dashboard
            </p>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default InstantPayTxnStatusCard;
